export function triggerBrowserDownload(url: string) {
  // Client-only
  if (typeof document === 'undefined') {
    return
  }

  const a = document.createElement('a')
  a.href = url
  a.download = ''
  a.rel = 'noopener'
  document.body.appendChild(a)
  a.click()
  a.remove()
}
